import { render, staticRenderFns } from "./swiperList.vue?vue&type=template&id=b79073d0&scoped=true&"
import script from "./swiperList.vue?vue&type=script&lang=js&"
export * from "./swiperList.vue?vue&type=script&lang=js&"
import style0 from "./swiperList.vue?vue&type=style&index=0&id=b79073d0&lang=scss&scoped=true&"
import style1 from "./swiperList.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b79073d0",
  null
  
)

export default component.exports